export default __webpack_public_path__ + "static/media/CoreUI-Icons-Free.428e3f64.ttf";